import React, { useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";

import { MenuTab } from "./MenuTab";
import { ParameterTab } from "./ParameterTab";
import { fetchMenuModal } from "./menuSlice";
import { useDispatch } from "react-redux";

export const MasterMenuPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      fetchMenuModal({
        pageNo: 1,
        pageSize: -1,
      })
    );
  }, [dispatch]);
  return (
    <>
      <div>
        <Tabs defaultActiveKey="Menu" id="uncontrolled-tab-example">
          <Tab eventKey="Menu" title="Menu">
            <MenuTab />
          </Tab>
          <Tab eventKey="Tree" title="Tree">
            <ParameterTab />
          </Tab>
        </Tabs>
      </div>
    </>
  );
};
